import { StyledFlag } from 'components/shared/BadgeFlag.styled';
import { Heading2 } from 'components/shared/Typography.styled';
import styled from 'styled-components';
import {
  color,
  container,
  fontFamily,
  fontSize,
  fontWeight,
  radius,
  screen,
  shadow,
  spacing
} from 'theme';

export const StyledWrapper = styled.div`
  background-color: ${color('midnight_100')};
  padding-top: ${spacing('xl5')};
  padding-bottom: ${spacing('xl5')};
`;

export const StyledContainer = styled.div`
  max-width: ${container('xl')};
  padding-left: ${spacing('md')};
  padding-right: ${spacing('md')};
  margin: 0 auto;

  ${Heading2} {
    text-align: center;
    margin-bottom: ${spacing('xl2')};
    margin-top: 0;
  }
`;

export const StyledList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing('xl2')};

  @media (min-width: ${screen('lg')}) {
    flex-direction: row;
    align-items: stretch;
    gap: ${spacing('xl')};
  }
`;

export const StyledItem = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 25rem;
  background-color: ${color('white')};
  border-radius: ${radius('lg')};
  padding: ${spacing('mdlg')} ${spacing('md')} 0;
  box-shadow: ${shadow('lg')};

  @media (min-width: ${screen('md')}) {
    padding: ${spacing('xl2')} ${spacing('xl2')} 0;
  }
`;

export const StyledTitle = styled.h4`
  font-size: ${fontSize('lg')};
  line-height: 1.2;
  font-weight: ${fontWeight('black')};
  display: flex;
  flex-direction: column;
  gap: ${spacing('md')};
  margin-top: 0;
  margin-bottom: ${spacing('md')};

  @media (min-width: ${screen('md')}) {
    font-size: ${fontSize('xl')};
    line-height: 1.14;
  }

  &::before {
    content: '';
    width: ${spacing('xl')};
    height: ${spacing('xs2')};
    background-color: ${color('cyan_700')};
  }
`;

export const StyledAds = styled.div`
  background-color: ${color('midnight_150')};
  border-radius: ${radius('sm')};
  padding: ${spacing('xs')};
  font-size: ${fontSize('sm')};
  line-height: 1;
  font-weight: ${fontWeight('black')};
  color: ${color('text_subtle')};
  text-transform: uppercase;
`;

export const StyledFeatures = styled.ul`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: ${spacing('mdlg')};
  margin-top: ${spacing('mdlg')};
  margin-bottom: ${spacing('md')};
`;

export const StyledFeatureItem = styled.li`
  display: flex;
  gap: ${spacing('xs')};
  align-items: flex-start;
  line-height: 1.25;

  svg {
    color: ${color('positive_500')};
    width: ${spacing('md')} !important;
    height: ${spacing('md')};
  }
`;

export const StyledPrice = styled.div`
  background-color: ${color('midnight_100')};
  padding: ${spacing('md')};
  margin: 0 -${spacing('md')};
  border-radius: 0 0 ${radius('lg')} ${radius('lg')};
  display: flex;
  align-items: center;
  gap: ${spacing('sm')};

  @media (min-width: ${screen('md')}) {
    padding: ${spacing('md')} ${spacing('xl2')};
    margin: 0 -${spacing('xl2')};
  }

  ${StyledFlag} {
    padding-top: ${spacing('xs')};
    padding-bottom: ${spacing('xs')};
    font-size: ${fontSize('xs')};
  }
`;

export const StyledValue = styled.div`
  font-family: ${fontFamily('display')};
  font-size: ${fontSize('xl4')};
  font-weight: ${fontWeight('semiBold')};
`;
